import arrondiResult from '@/services/general/arrondiCalcul';

export function calculRemiseVenteLC(data, value) {
  if (data.extensionOpportunite.tarifAnnuel) {
    if (data.extensionOpportunite.typeDeRemise === 0) {
      data.extensionOpportunite.remise = arrondiResult(
        (data.extensionOpportunite.tarifAnnuel - value) * 100 /
          data.extensionOpportunite.tarifAnnuel);
    } else {
      data.extensionOpportunite.remise = arrondiResult(
        data.extensionOpportunite.tarifAnnuel - value);
    }
  }
  return data;
}

export function calculRemiseVenteRxTempo(data, value) {
  if (data.extensionOpportunite.tarifHT) {
    if (data.extensionOpportunite.typeDeRemise === 0) {
      data.extensionOpportunite.remise = arrondiResult(
        (data.extensionOpportunite.tarifHT - value) * 100 /
          data.extensionOpportunite.tarifHT);
    } else {
      data.extensionOpportunite.remise = arrondiResult(
        data.extensionOpportunite.tarifHT - value);
    }
  }
  return data;
}

export function calculRemiseVenteRxNumerique(data, value) {
  if (data.tarifBrut) {
    if (data.extensionOpportunite.typeDeRemise === 0) {
      data.extensionOpportunite.remise = arrondiResult(
        (data.tarifBrut - value) * 100 /
        data.tarifBrut);
    } else {
      data.extensionOpportunite.remise =
        arrondiResult(data.tarifBrut - value);
    }
  }
  return data;
}

export function calculRemiseVenteRxLc(data, value) {
  if (data.extensionOpportunite.tarifBrut) {
    if (data.extensionOpportunite.typeDeRemise === 0) {
      data.extensionOpportunite.remise =
        arrondiResult((data.extensionOpportunite.tarifBrut - value) * 100 /
          data.extensionOpportunite.tarifBrut);
    } else {
      data.extensionOpportunite.remise =
        arrondiResult(data.extensionOpportunite.tarifBrut - value);
    }
  }
  return data;
}



// WEBPACK FOOTER //
// ./src/services/calcul/calculRemise.js